<template>
  <div class="container">
    <div class="text-start d-flex mt-4 justify-content-between print-section">
      <div class="card-left col-12">
        <img
          :src="arData.logo || '@/assets/images/Logo.svg'"
          alt="Logo da Autoridade de Registro"
          class="doc-print-logo"
        />
        <div class="text-center fw-600">DOCUMENTO RESERVADO</div>
        <div class="divisor"></div>
        <div>Dados para emitir Certificado Digital após aprovação</div>
        <div>
          <strong>Código da solicitação: </strong>{{ form.codigoSolicitacao }}
        </div>
        <div class="divisor"></div>
        <div>
          Após aprovação da sua Solicitação, utilize os dados informados abaixo
          para fazer a instalação do Certificado Digital.
        </div>
        <div class="info-box">
          <span class="fw-600">Usuário: </span> {{ form.user }}
        </div>
        <div class="info-box">
          <span class="fw-600">Senha: </span> criada pelo usuário
        </div>
        <div class="divisor"></div>
        <div class="fw-600">Atenção</div>
        <div>
          <span class="fw-600">Para sua segurança</span>, guarde este documento
          em local seguro até que emita seu Certificado Digital Soluti.
        </div>
        <div>
          Após a emissão, esses dados não serão mais necessários e este
          documento poderá ser descartado.
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { mapState } from 'pinia'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'HomeView',
    data: () => ({
      form: {
        arsubdomain: '',
        codigoSolicitacao: '',
        user: '',
      },
    }),
    computed: {
      ...mapState(useAR, ['arData', 'getSubdomain']),
      ...mapState(useSolicitation, ['getSolicitation']),
      link() {
        if (process.env.NODE_ENV === 'development') {
          return `http://emissao-online-hom.soluti.com.br/${this.form.arsubdomain}/guia-de-instalacao-de-certificado-digital`
        }
        return `https://emissao-online.soluti.com.br/${this.form.arsubdomain}/guia-de-instalacao-de-certificado-digital`
      },
    },
    mounted() {
      this.form.arsubdomain = this.getSubdomain
      this.form.codigoSolicitacao = this.getSolicitation.cdSolicitacao
      this.form.user = this.getSolicitation.userName
    },
  })
</script>

<style lang="stylus" scoped>
  .doc-print-logo
    height: 60px
    object-fit: contain
    justify-content: center
    margin-bottom: 1rem

  .card-left
   display: flex
   flex-direction: column

   border-radius: 10px
   border: 1px solid #E6E7EC
   gap: 1rem
   padding: 24px 16px 24px 16px
   background-color: #FFFFFF

  .divisor
   border-bottom: 1px solid #E6E7EC

  .info-box
   border-radius: 8px
   padding: 10px
   background-color: #F0F0F3

   @media print {
    .print-section {
      display: block; /* Torna visível apenas durante a impressão */
    }
  }
</style>
